import defaultPrimary from '../default/primary';

const light = (params) => defaultPrimary(params);

export default light;
